import React, { useState, useEffect } from "react";
import { Form, Col, Row, Button, Select, Collapse, DatePicker } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { odata } from "./Helper";
import RequestHandler from "util/RequestHandler";

const StockMovementHistoryFilter = (props) => {
  const [form] = Form.useForm();
  const [stockSelect, setStockSelect] = useState({
    data: [],
    loading: false,
  });
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });

  useEffect(() => {
    getCurrencies();
  }, []);

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });
    RequestHandler.get(`/Currency/GetFilterCurrency`).then((response) => {
      setCurrencySelect({
        data: response,
        loading: false,
      });
    });
  };

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.stockId) {
        conditions.push(`stockId eq ${values.stockId}`);
      }
      if (values.dateRange) {
        const [startDate, endDate] = values.dateRange;

        conditions.push(odata.dateRange("addDate", startDate, endDate));
      }
      if (values.stockMovementType) {
        conditions.push(`stockMovementType eq ${values.stockMovementType}`);
      }
      if (values.currencyCode) {
        conditions.push(`currencyCode eq  '${values.currencyCode}'`);
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query, values);
    }
  };

  const onStockSearch = (value) => {
    if (value.length >= 2) {
      setStockSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Stock?$select=id,stockCode,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("stockCode", value)}) and Name ne 'Diğer'`
      ).then((res) => {
        setStockSelect({ data: res.value, loading: false });
      });
    } else {
      setStockSelect({ data: [], loading: false });
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col
                  xs={24}
                  md={12}
                  lg={6}
                  hidden={props.isUseStockId == true ? false : true}
                >
                  <Form.Item name="stockId" label="Ürün Adı :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onStockSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={stockSelect.loading}
                    >
                      {stockSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.stockCode}
                        >
                          {item.name + " (" + item.stockCode + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Hareket Tipi" name="stockMovementType">
                    <Select allowClear showSearch>
                      <Select.Option key={1} value={1}>
                        Stok Girişi
                      </Select.Option>
                      <Select.Option key={2} value={2}>
                        Stok Çıkışı
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="currencyCode" label="Para Birimi :">
                    <Select
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={currencySelect.loading}
                    >
                      {currencySelect.data.map(({ text, value }) => (
                        <Select.Option key={text} value={text}>
                          {value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="dateRange" label="Hareket Tarihi">
                    <DatePicker.RangePicker
                      style={{ width: "100%" }}
                      picker={props.monthly ? "month" : "date"}
                      format={props.monthly ? "MMMM YYYY" : "DD.MM.YYYY"}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default StockMovementHistoryFilter;
